const notifications = {
  lockdown: 'Lockdown',
  door_alarmed: 'Door Forced',
  reader_tamper: 'Reader Tamper',
  tamper: 'Enclosure Tamper',
  batteries_trouble: 'Battery Troubles',
  power_trouble: 'Primary Power Trouble',
  module_offline: 'Offline Module',
};

export default notifications;
